import { useState, useEffect, useMemo, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { toastErrorLog } from '../../helpers/toastErrorLog'
import { useAuth } from '../../hooks/useAuth'
import { useImagenesPublicacion } from '../../hooks/useImagenesPublicacion'
import ComponenteError from '../publicaciones/ComponenteError'
import Publicacion from '../publicaciones/Publicacion'
import * as favoritosService from '../servicios/favoritosService'
import styles from './Favoritos.module.css'

const CANTIDAD_SKELETONS = 4

const Favoritos = () => {
  const imagenesFetchKeyRef = useRef('')
  const [favoritos, setFavoritos] = useState([])
  const [cargando, setCargando] = useState(true)
  const navigate = useNavigate()
  const { loginDataContext: { idUsuario } = {} } = useAuth()
  const { adjuntos, loadingImagenes, fetchImagenes } = useImagenesPublicacion()

  useEffect(() => {
    const fetchFavoritos = async () => {
      const userId = idUsuario
      if (!userId) return

      setCargando(true)
      try {
        const { data: favoritos } = await favoritosService.buscarPorUsuario(userId)
        setFavoritos((favoritos ?? []).filter((fav) => fav.idVendedor !== parseInt(userId)))
      } catch (error) {
        toastErrorLog(error, 'No se pudieron cargar tus favoritos.', 'favoritos')
        setFavoritos([])
      } finally {
        setCargando(false)
      }
    }

    fetchFavoritos()
  }, [idUsuario])
  const idsPublicacionesParaImagenes = useMemo(
    () => favoritos.map((p) => p.idPublicacion),
    [favoritos]
  )
  useEffect(() => {
    if (idsPublicacionesParaImagenes.length === 0) {
      return
    }

    const fetchKey = idsPublicacionesParaImagenes.join(',')
    if (imagenesFetchKeyRef.current === fetchKey) {
      return
    }

    imagenesFetchKeyRef.current = fetchKey
    fetchImagenes({ idPublicaciones: idsPublicacionesParaImagenes })
  }, [idsPublicacionesParaImagenes])
  const handleToggle = (event, favorito, idPublicacion) => {
    navigate(`/Publicacion/${idPublicacion}`)
  }

  const updateFavoritos = async (idpub) => {
    setFavoritos((prev) => prev.filter((pub) => pub.idPublicacion !== idpub))
  }

  return (
    <fieldset className={styles.fieldset}>
      <legend>
        <span>Mis Favoritos</span>
        {!cargando && favoritos.length > 0 && (
          <span className={styles.ayuda}>
            Tocá el <i className="fa fa-heart" aria-hidden="true" /> de una publicación para
            quitarla de tus favoritos.
          </span>
        )}
      </legend>
      <div className={styles.grid}>
        {cargando ? (
          Array.from({ length: CANTIDAD_SKELETONS }, (_, i) => (
            <div key={i} className={styles.skeleton} aria-hidden="true">
              <span className={styles.skeletonImagen} />
              <span className={styles.skeletonLineas}>
                <span className={styles.skeletonLinea} />
                <span className={`${styles.skeletonLinea} ${styles.skeletonLineaCorta}`} />
              </span>
            </div>
          ))
        ) : favoritos.length > 0 ? (
          favoritos.map((publicacion) => (
            <Publicacion
              key={publicacion.idPublicacion}
              onToggleClick={handleToggle}
              publicacion={publicacion}
              compFavorito={true}
              onDelete={updateFavoritos}
              adjunto={adjuntos.find((a) => a.idPublicacion === Number(publicacion.idPublicacion))}
              loadingImagenes={loadingImagenes}
            />
          ))
        ) : (
          <div className={styles.vacio}>
            <ComponenteError tipo="i" idAviso={5} />
          </div>
        )}
      </div>
    </fieldset>
  )
}

export default Favoritos
